import { StringParam, ObjectParam, JsonParam, ArrayParam, BooleanParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'
import { dateFormat } from '@app/constants'

import { PRODUCT_PRICING_STATES_TITLE } from './constants'

import type { ColumnTitleSchema } from '@app/types/table'
import type { ProductPricingListDataSource } from './types'
import type { ColumnTableSchema } from '@app/components/ExtendedTable/types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'

export const columnTitleMap: ColumnTitleSchema<ProductPricingListDataSource> = {
  productCode: 'Код товара',
  monitoringKind: 'Вид мониторинга',
  monitoringType: 'Тип мониторинга',
  name: 'Наименование товара',
  purchasingGroup: 'ГЗ',
  category: 'Категория',
  categoryId: 'Код категории',
  isShortKvi: 'ShortKVI',
  isEPP: 'EPP',
  cluster: 'Кластер',
  store: 'ТК Ленты',
  monitoringStartAt: 'Дата старта',
  deadline: 'Дедлайн обработки',
  sentAt: 'Дата передачи',
  state: 'Статус передачи'
}

export const columnSettingSchema: ColumnTableSchema<ProductPricingListDataSource> = {
  monitoringKind: { customEllipsis: true },
  monitoringType: { customEllipsis: true },
  name: { customEllipsis: true }
}

export const tableSearchQuerySchema: TableSearchQuerySchema<ProductPricingListDataSource> = {
  'table-productCode': StringParam,
  'table-monitoringKind': StringParam,
  'table-monitoringType': StringParam,
  'table-name': StringParam,
  'table-purchasingGroup': StringParam,
  'table-cluster': StringParam,
  'table-store': StringParam,
  'table-monitoringStartAt': ObjectParam,
  'table-deadline': ObjectParam,
  'table-sentAt': ObjectParam,
  'table-state': JsonParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

const options = Object.entries(PRODUCT_PRICING_STATES_TITLE).map(([key, value]) => ({
  label: value,
  value: key
}))

export const columnsSearchSchema: ColumnTableSearchSchema<ProductPricingListDataSource> = {
  productCode: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringKind: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  name: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringStartAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  deadline: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  sentAt: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  state: { type: columnSearchSchemaOptionType.SELECT, titleWrapperProps, controlProps: { options } }
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringKindIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.categoryIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.purchasingGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.productCodes]: ArrayParam,
  [FILTERS_PARAMS_KEYS.productNames]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringStartAtBefore]: StringParam,
  [FILTERS_PARAMS_KEYS.monitoringStartAtAfter]: StringParam,
  [FILTERS_PARAMS_KEYS.deadlineBefore]: StringParam,
  [FILTERS_PARAMS_KEYS.deadlineAfter]: StringParam,
  [FILTERS_PARAMS_KEYS.state]: ArrayParam,
  [FILTERS_PARAMS_KEYS.isShortKvi]: BooleanParam,
  [FILTERS_PARAMS_KEYS.isEPP]: BooleanParam
}
